import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomParagraphComponent } from './custom-paragraph.component';
import {CmsConfig, ConfigModule} from "@spartacus/core";

@NgModule({
  declarations: [CustomParagraphComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSParagraphComponent: {
          component: CustomParagraphComponent,
        },
        CMSTabParagraphComponent: {
          component: CustomParagraphComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomParagraphModule { }
